<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý serial number</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('serial_number', 'view_serial')">
        <div class="box-top-list-serial-number" >
          <div class="box-import">
            <div class="box-title">Chi tiết serial number</div>
          </div>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="p-fluid ">
          <div class="p-col-12 p-grid">
            <div class="view-serial-number p-col-6">
              <div class="form-info">
                <div class="p-field">
                  <label>Model sản phẩm</label>
                  <span>{{ model_code }}</span>
                </div>
                <div class="p-field">
                  <label>Tên sản phẩm</label>
                  <span>{{ model_name }}</span>
                </div>
                <div class="p-field">
                  <label>Serial number</label>
                  <span>{{ serial_number }}</span>
                </div>
                <div class="p-field">
                  <label>Nhóm sản phẩm</label>
                  <span>{{ categories }}</span>
                </div>
                
                <div class="p-field">
                  <label>Ngày sản xuất</label>
                  <span>{{ date_production }}</span>
                </div>

                <div class="p-field">
                  <label>Trạng thái bảo hành</label>
                  <span v-html="warranty_status"></span>
                </div>
                
              </div>
            </div>
            <div class="view-serial-number p-col-6">
              <div class="form-info">
                <div class="p-field">
                  <label>Thời hạn bảo hành</label>
                  <span v-html="warranty_time"></span>
                </div>

                <div class="p-field">
                  <label>Thời hạn đổi</label>
                  <span v-html="change_time"></span>
                </div>

                 <div class="p-field">
                  <label>Thời hạn trả</label>
                  <span v-html="returnable_time"></span>
                </div>

                <div class="p-field">
                  <label>Ngày bán sản phẩm</label>
                  <span>{{ date_of_sale }}</span>
                </div>
                <div class="p-field">
                  <label>Ngày kích hoạt bảo hành</label>
                  <span>{{ activation_date }}</span>
                </div>
                <div class="p-field">
                  <label>Ngày hết hạn bảo hành</label>
                  <span>{{ expired_activation_date }}</span>
                </div>
                <!-- <div class="p-field">
                  <label>Lý do đổi thời hạn BH</label>
                  <span>{{ reason_warranty }}</span>
                </div> -->
                
              </div>
            </div>
          </div>
        </div>
        <div class="box-top-list-serial-number" v-if="$myConstants.checkRoleGroup('serial_number', 'history_product')" >
          <div class="box-import">
            <div class="box-title">Lịch sử của sản phẩm</div>
          </div>
          <div class="log-changed warranty-history">
            <ListView v-if="dataModelLog"
              :key="componentKeyLog"
              :listData="listDataLog"
              :model="dataModelLog"
              :isFilter="false"
              :isExpand="true"
              :subModel="subModelLog"
              :subParams="subParams"
              :subOrderBy="subOrderBy"
              :pagination="false"
              @callback="callback"
            ></ListView>
          </div>
        </div>
        <!--<div class="box-top-list-serial-number" >
          <div class="box-import">
            <div class="box-title">Lịch sử sửa chữa bảo hành</div>
          </div>
          <div class="log-changed repair-history">
            <BaseCommon v-if="dataModelRepair"
              :key="componentKeyRepair"
              :listData="listDataRepair"
              :model="dataModelRepair"
              :isFilter="false"
              :pagination="false"
              @callback="callbackRepair"
            ></BaseCommon>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import ListView from './list_view'
//import BaseCommon from '../common'
export default {
  components: {
    //BaseCommon,
    ListView
  },
  data() {
    return {
        filters: {},
        listData: [],
        serial_number_id: 0,
        listDataRepair: [],
        dataModelRepair: null,
        componentKeyRepair: 0,
        date_production: '',
        date_of_sale: '',
        reason_warranty: '',
        activation_date: '',
        returnable_time: 0,
        change_time: 0,
        warranty_time: 0,
        expired_activation_date: '',
        categories : '',
        serial_number: '',
        warranty_status: '',
        model_code: '',
        model_name: '',
        listDataLog: [],
        dataModelLog: null,
        componentKey: 0,
        componentKeyLog: 0,
        subModelLog: null,
        subParams: [],
        subOrderBy: ''
    }
  },
  
  watch: {
    '$route': 'initParams'
  },
  async created () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.serial_number_id = this.$route.params.id;
      await this.getDataProduct();
      await this.getDataProductInfo();
      await this.initParams();
      await this.getDataLog();
    }
  },
  methods: {
    backList() {
       this.$router.push({path: '/admin/serial-number'});
    },
    callback(col, payload) {
      if (payload.request_activation_product_serial != undefined && payload.request_activation_product_serial != null && Object.keys(payload.request_activation_product_serial).length > 0) {
        var payloadID = payload.request_activation_product_serial[0].id;
        this.$router.push({path: '/admin/warranty-activation/view-detail/' + payloadID });
      }
    },
    callbackRepair() {
      this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Đang xây dựng', life: 3000 })
    },
    async initParams() {
      /*var list = [];
      this.dataModelRepair = DataServices.getModel('warranty_repair_history');
      this.listDataRepair = list;
      this.componentKeyRepair++;*/
    },
    async getDataProduct() {
      var name = 'product_serial_number';
      var variables = {
        where_key: {
          id: {'_eq': this.serial_number_id },
          status: {'_eq': 1}
        }
      }
     
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": "serial_number production_order_code created_date modified_date production_status warranty_status product { model_code name warranty_time returnable_time change_time categories { name } } production_order_code_one { manufacturing_date }"});
      var list = data[Object.keys(data)];
      if (list != null && list.length) {
        this.listData = list[0];
        if (this.listData.product != undefined && this.listData.product != null) {
          this.categories = (this.listData.product.categories != undefined && this.listData.product.categories != null ) ? this.listData.product.categories.name : '';
          this.serial_number = (this.listData.serial_number != undefined && this.listData.serial_number != null ) ? this.listData.serial_number : '';
          this.date_production = (this.listData.production_order_code_one != undefined && this.listData.production_order_code_one != null ) ? moment(this.listData.production_order_code_one.manufacturing_date).format('DD/MM/YYYY') : '';
          this.returnable_time = this.listData.product.returnable_time;
          this.change_time =  (this.listData.product.change_time != undefined && this.listData.product.change_time != null) ? this.listData.product.change_time : 0;
          this.warranty_time = this.listData.product.warranty_time;
          this.model_code = this.listData.product.model_code;
          this.model_name = this.listData.product.name;
          var warranty_unit = 'month';// của sản phẩm mặc định đơn vị là tháng
          var warranty_status = parseInt(this.listData.warranty_status);
          if (warranty_status == 2) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(153, 0, 204);">Chờ kích hoạt</abbr>';
          else if (warranty_status == 0 || warranty_status == 5) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgba(255, 102, 0, 1);">Chưa kích hoạt</abbr>';
          else if (warranty_status == 4) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(51, 0, 204);">Hết bảo hành</abbr>';
          else if (warranty_status == 6) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 0, 0);">Sản phẩm huỷ</abbr>';
          else if (warranty_status == 3 || warranty_status == 1) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 204, 0);">Đã kích hoạt</abbr>';
          var dataDateArr = {
            warranty_time:this.warranty_time,
            returnable_time:this.returnable_time,
            change_time:this.change_time,
            warranty_status:warranty_status,
            activation_date:this.listData.activation_date,
            arrWarrantyStatus:null,
            warranty_unit:warranty_unit,
          }
          var arrs = this.$myConstants.returnDateCustomText(dataDateArr);
          this.warranty_time = arrs.warranty_time_text;
          this.returnable_time = arrs.returnable_time_text;
          this.change_time = arrs.change_time_text;
        }
      }
    },
    async getDataProductInfo() {
      var name = 'product_serial_number_info';
      var variables = {
        where_key: {
          serial_number_id: {'_eq': this.serial_number_id },
          status: {'_eq': 1}
        }
      }
     
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": "model_code name warranty_time warranty_unit returnable_time change_time warranty_status verify_status date_of_sale activation_date categories { name  } product_serial_number { serial_number created_date modified_date production_order_code_one { manufacturing_date } }"});
      var list = data[Object.keys(data)];
      if (list != null && list.length) {
        this.listData = list[0];
        console.log("this.listDatathis.listData:",this.listData)
        // this.activation_date = this.listData.activation_date;
        this.returnable_time = this.listData.returnable_time;
        this.change_time =  (this.listData.change_time != undefined && this.listData.change_time != null) ? this.listData.change_time : 0;
        this.warranty_time = this.listData.warranty_time;
        var warranty_unit = this.listData.warranty_unit;
        if(this.listData.activation_date != null && this.listData.warranty_time != null && (this.listData.warranty_status == 3 || this.listData.warranty_status == 4)) {
          var map_warranty_unit = this.$dataCommon.COVERT_UNIT_MOMMENT[warranty_unit];
          this.expired_activation_date = moment(this.listData.activation_date).add(this.warranty_time, map_warranty_unit).format('DD/MM/YYYY');
        }
        if (this.listData.warranty_status == 3 || this.listData.warranty_status == 4) {
          this.activation_date =  moment(this.listData.activation_date).format('DD/MM/YYYY');
        }
        if(this.listData.date_of_sale != null  && this.listData.warranty_status !== 0 && (this.listData.warranty_status == 2 || this.listData.warranty_status == 3 || this.listData.warranty_status == 4)) {
          this.date_of_sale = moment(this.listData.date_of_sale).format('DD/MM/YYYY');
        }
        if(this.listData.product_serial_number.modified_date != null) {
          this.created_date = moment(this.listData.product_serial_number.modified_date).format('DD/MM/YYYY');
        } else if(this.listData.product_serial_number.created_date != null) {
          this.created_date = moment(this.listData.product_serial_number.created_date).format('DD/MM/YYYY');
        }
        this.categories = (this.listData.categories != undefined && this.listData.categories != null ) ? this.listData.categories.name : '';
        this.serial_number = (this.listData.product_serial_number != undefined && this.listData.product_serial_number != null ) ? this.listData.product_serial_number.serial_number : '';
        this.date_production = (this.listData.product_serial_number != undefined && this.listData.product_serial_number != null && this.listData.product_serial_number.production_order_code_one != undefined && this.listData.product_serial_number.production_order_code_one != null) ? moment(this.listData.product_serial_number.production_order_code_one.manufacturing_date).format('DD/MM/YYYY') : '';
        this.model_code = this.listData.model_code;
        this.model_name = this.listData.name;
        if (this.listData.warranty_status == 2) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(153, 0, 204);">Chờ kích hoạt</abbr>';
        else if (this.listData.warranty_status == 0 || this.listData.warranty_status == 5) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgba(255, 102, 0, 1);">Chưa kích hoạt</abbr>';
        else if (this.listData.warranty_status == 4) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(51, 0, 204);">Hết bảo hành</abbr>';
        else if (this.listData.warranty_status == 6) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 0, 0);">Sản phẩm huỷ</abbr>';
        else if (this.listData.warranty_status == 3 || this.listData.warranty_status == 1) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 204, 0);">Đã kích hoạt</abbr>';
        await this.getDataLogLast(this.serial_number_id);
        var dataDateArr = {
          warranty_time:this.warranty_time,
          returnable_time:this.returnable_time,
          change_time:this.change_time,
          warranty_status:this.listData.warranty_status,
          activation_date:this.listData.activation_date,
          arrWarrantyStatus:null,
          warranty_unit:warranty_unit,
        }
        var arrs = this.$myConstants.returnDateCustomText(dataDateArr);
        this.warranty_time = arrs.warranty_time_text;
        this.returnable_time = arrs.returnable_time_text;
        this.change_time = arrs.change_time_text;
      }
    },
    async getDataLogLast(serial_number_id) {
      var nameLog = 'product_serial_number_info_log_changed';
      var variables = {
        where_key: {
          serial_number_id: {'_eq': serial_number_id}
        },
        orderBy: {
          modified_date: 'desc'
        },
        limit: 1
      }
      var data = await DataServices.getList(nameLog, {"fileds": "new_value", "variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list && list.length > 0) {
        var firstData = list[0];
        var newValue = firstData.new_value;
        if (newValue && newValue != null) {
          var jsonValue = JSON.parse(newValue);
          if (jsonValue && jsonValue != null && jsonValue.warranty_message != undefined && jsonValue.warranty_message != null) {
            this.reason_warranty = jsonValue.warranty_message;
          }
        }
      }
    },
    async getDataLog() {
      this.subModelLog = DataServices.getModel('view_product_serial_number_info_history_detail');
      var nameLog = 'request_activation_expand';
      var variables = {
        where_key: {
          request_activation_product_serial: {
            serial_number_id: {'_eq': this.serial_number_id}
          }
        }
      }
      this.subParams.push({key: 'customer_profile_id', condition: '_eq', field: 'customer_profile_id'});
      this.subParams.push({key: 'serial_number_id', condition: '_eq', value: this.serial_number_id});
      this.subOrderBy = '"log_modified_date": "desc"';
      var variableHistoryDetail = {"where_key": {"serial_number_id": {"_eq":this.serial_number_id}},"orderBy": {"log_modified_date": "desc"}};
      //Lấy danh sách lịch sử bảo hành
      var dataHistoryDetail = await DataServices.getList('view_product_serial_number_info_history_detail', {"variables": JSON.stringify(variableHistoryDetail)});
      var listHistoryDetail = dataHistoryDetail[Object.keys(dataHistoryDetail)];
      var mapHistoryDetail = {};
      if (listHistoryDetail.length > 0){
        for (var h=0;h<listHistoryDetail.length;h++){
          var key_map = "k_"+listHistoryDetail[h].customer_profile_id;
          if (this.$myConstants.isEmpty(mapHistoryDetail[key_map])){
            //Nếu chưa tồn tại thì khởi tạo
            mapHistoryDetail[key_map] = [];
          }
          mapHistoryDetail[key_map].push(listHistoryDetail[h]);
        }
      }

      //Lấy danh sách lịch sử sữa chữa
      var variablesHistoryUpdate = {
        where_key: {
          status: {'_in': [1] },
          //warranty_repair_product_serial_number_id: {_eq: wr_product_serial_number_id},
          obj_wr_product_serial_number: {serial_number_id: {_eq: this.serial_number_id}, _or: [{type_service: {_is_null: true}},{type_service: {_neq: this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE}}]}
        },
        orderBy: {
          id: 'desc',
        }
      }
      var dataHistoryUpdate = await DataServices.getList('list_history_update_repair_serial', {"variables": JSON.stringify(variablesHistoryUpdate)});
      var listHistoryUpdate = dataHistoryUpdate[Object.keys(dataHistoryUpdate)];
      console.log("listHistoryUpdate",listHistoryUpdate);
      var mapHistoryUpdate = {};
      if (listHistoryUpdate.length > 0){
        for (var u=0;u<listHistoryUpdate.length;u++){
          if (!this.$myConstants.isEmpty(listHistoryUpdate[u].obj_wr_product_serial_number)){
            if (!this.$myConstants.isEmpty(listHistoryUpdate[u].obj_wr_product_serial_number.serial_user_id)){
              var key_user_id_u = "k_"+listHistoryUpdate[u].obj_wr_product_serial_number.serial_user_id;
              if (this.$myConstants.isEmpty(mapHistoryUpdate[key_user_id_u])){
                //Nếu chưa tồn tại thì khởi tạo
                mapHistoryUpdate[key_user_id_u] = [];
              }
              mapHistoryUpdate[key_user_id_u].push(listHistoryUpdate[u]);
            }
          }
        }
      }

      //Lấy danh sách thông tin bảo trì
      var variablesMaintenanceSerial = {
        where_key: {
          status: {'_in': [0, 1] },
          serial_number_id: {_eq: this.serial_number_id}
        },
        orderBy: [
          {parts_number: 'asc'},
          {date_maintenance: 'desc'}
        ]
      }
      /*var array_sort_status = {
        0:1,
        1:0,
        2:2,
        3:4,
        4:4,
        5:5,
      };*/
      var dataMaintenanceSerial = await DataServices.getList('maintenance_serial', {"variables": JSON.stringify(variablesMaintenanceSerial)});
      var listMaintenanceSerial = dataMaintenanceSerial[Object.keys(dataMaintenanceSerial)];
      var list_id_maintence = [];
      if (listMaintenanceSerial.length > 0){
        for (var i=0;i<listMaintenanceSerial.length;i++){
          //listMaintenanceSerial[i].sortProcessStatus = array_sort_status[listMaintenanceSerial[i].process_status];
          list_id_maintence.push(listMaintenanceSerial[i].id);
        }
      }
      var map_wr_product = {};
      if (list_id_maintence.length > 0){
        var variables_wr_product_serial_number = {
          where_key: {
            check_maintenance_period : {_in: list_id_maintence}
          },
          orderBy: {"id": "desc"}
        }
        var wr_product_serial_number = await DataServices.getList('warranty_repair_product_serial_number', {"variables": JSON.stringify(variables_wr_product_serial_number), "fields": "id check_maintenance_period"});
        var list_wr_product = wr_product_serial_number[Object.keys(wr_product_serial_number)];
        for (var w=0;w<list_wr_product.length;w++){
          map_wr_product[list_wr_product[w].check_maintenance_period] = list_wr_product[w];
        }
      }
      var mapMaintennance = {};
      if (listMaintenanceSerial.length > 0) {
        for (var j = 0; j < listMaintenanceSerial.length; j++) {
          if (!this.$myConstants.isEmpty(map_wr_product[listMaintenanceSerial[j].id])){
            listMaintenanceSerial[j].id_wr_product = map_wr_product[listMaintenanceSerial[j].id].id;
          }

        }
        //listMaintenanceSerial.sort((a,b)=> (a.sortProcessStatus - b.sortProcessStatus ||  new Date(b.date_maintenance) - new Date(a.date_maintenance) || b.parts_number - a.parts_number ));
        for (var p = 0; p < listMaintenanceSerial.length; p++) {
          var key_user_id_m = "k_"+listMaintenanceSerial[p].serial_user_id;
          if (this.$myConstants.isEmpty(mapMaintennance[key_user_id_m])){
            //Nếu chưa tồn tại thì khởi tạo
            mapMaintennance[key_user_id_m] = [];
          }
          mapMaintennance[key_user_id_m].push(listMaintenanceSerial[p]);
        }
      }
      var data = await DataServices.getList(nameLog, {"variables": JSON.stringify(variables), "distinct": "customer_profile_id",  "fields": "id customer_profile_id modified_date request_activation_product_serial(where: {serial_number_id: {_eq: " + this.serial_number_id + "}}) { id serial_number_id verify_status warranty_status } customer_profile { user_id full_name } organizations { name } "});
      var list = data[Object.keys(data)];
      this.dataModelLog = DataServices.getModel(nameLog);
      this.dataModelLog.processData(list);
      for (var l=0;l<list.length;l++){
        var key_map_l = "k_"+list[l].customer_profile_id;
        if (!this.$myConstants.isEmpty(mapHistoryDetail[key_map_l])){
          list[l].list_history_detail = mapHistoryDetail[key_map_l];
        }else {
          list[l].list_history_detail = [];
        }
        list[l].list_history_update = [];
        if (!this.$myConstants.isEmpty(list[l].customer_profile)){
          if (!this.$myConstants.isEmpty(list[l].customer_profile.user_id)){
            var key_user_id = "k_"+list[l].customer_profile.user_id;
            //list lịch sử sữa chữa bảo hành => lấy trạng thái cuối cùng
            var list_history_update = (!this.$myConstants.isEmpty(mapHistoryUpdate[key_user_id])) ? mapHistoryUpdate[key_user_id]:[];
            /*var list_history_update_tmp = [];
            if (list_history_update.length > 0){
              list_history_update_tmp.push(list_history_update[0]);
            }*/
            //Lấy trạng thái mới nhất của mỗi dịch vụ

            list[l].list_history_update = this.get_history_last_repair(list_history_update);
            list[l].list_maintennance = (!this.$myConstants.isEmpty(mapMaintennance[key_user_id])) ? mapMaintennance[key_user_id]:[];
          }
        }

      }
      this.listDataLog = list;
      this.listDataLog.sort(function(a,b){return new Date(b.modified_date).getTime() -  new Date(a.modified_date).getTime()});
      this.componentKeyLog =  Math.random() * 100;
    },
    get_history_last_repair(list_history_update) {
      var list_map = {};
      if (list_history_update.length > 0) {
        for (var i = 0; i < list_history_update.length; i++) {
          var warranty_repair_id = list_history_update[i].obj_wr_product_serial_number.warranty_repair_id;
          var key_map = "k_" + warranty_repair_id;
          //nếu ko tồn tại push vào
          if (this.$myConstants.isEmpty(list_map[key_map])) {
            list_map[key_map] = list_history_update[i];
          }
        }
      }
      var list_data = [];
      for (const [key, value] of Object.entries(list_map)) {
        list_data.push(value);
        if (key) ;
      }
      return list_data;
    }
  }
}
</script>

<style lang="scss">
.repair-history{ margin-top: 20px;}
.warranty-history { margin-top: 20px;}
.create-serial-number{ margin: 0 auto; width: 800px;
    .p-field{
        &.width-prefix{width: 125px;}
        &.width-amount{margin-left: 20px; width: 200px; margin-right: 100px;}
        &.width-300{width: 350px;
            &.margin-right{margin-right: 100px;}
        }
        label{font-size: 14px;}
        &.btn-submit{ margin: 20px auto 0 auto;
            .p-button{width: 200px !important; 
                &.disabled{background: #999999; border: 1px solid #999999;}
            }
        }
    }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.box-top-list-serial-number{ margin-bottom: 10px; margin-top: 20px;
  .box-import{display: inline-block;}
  .right-button{float: right;}
}
.view-serial-number{
  .box-info-title{ margin-bottom: 20px;}
  .form-info{
    .p-field{ padding: 10px;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
    }
  }
}
.timeline{ font-weight: bold; font-style: italic; padding-left: 5px;}
</style>
<style>
.class_status_plain{
  color: #00CC00;
}
.class_status_maintenance_needed{
  color: #FF6600;
}
.class_status_processing{
  color: #990099;
}
.class_status_for_maintenance{
  color: #0066FF;
}
.class_status_out_of_date{
  color: #CC0000;
}
.class_status_cancel_plan_only{
  color: #666666;
}
</style>